(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("._regular_1luxt_1{color:var(--text-and-icon-primary-default, #353535);font-family:CoFo Sans,sans-serif;font-size:2.1875rem;font-style:normal;line-height:2.5rem;font-weight:400}._medium_1luxt_10{color:var(--text-and-icon-primary-default, #353535);font-family:CoFo Sans,sans-serif;font-size:2.1875rem;font-style:normal;line-height:2.5rem;font-weight:500}._bold_1luxt_19{color:var(--text-and-icon-primary-default, #353535);font-family:CoFo Sans,sans-serif;font-size:2.1875rem;font-style:normal;line-height:2.5rem;font-weight:700}")),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
const l = "_regular_1luxt_1", t = "_medium_1luxt_10", u = "_bold_1luxt_19", e = {
  regular: l,
  medium: t,
  bold: u
};
export {
  u as bold,
  e as default,
  t as medium,
  l as regular
};
